/**
 * The document title Inertia's `<Head>` produces from a page's title segment.
 *
 * Shared by the browser entry (app.ts) and the SSR renderer so a server-rendered
 * document and its client hydration agree on the `<title>` byte for byte.
 */
export const formatDocumentTitle = (title: string | undefined | null, siteName: string): string => (title ? `${title} | ${siteName}` : siteName);
